module.exports = __webpack_public_path__ + "1ce86e343fab916861ff85921809af3a.png";